module.exports = {
  env: 'test',
  domain: ['v2test.tsepcn.com'],
  mobileDomain: 'v2testh5.tsepcn.com',
  aegisId: 'akNqIsanJXJnMpAhyv',
  reportDomain: 'baike.sparta.html5.qq.com',
  cosAppId: 'tsep_dev',
  bucket: 'tsep-test-1304685099',
  region: 'ap-guangzhou',
};
